/* compare-ui.js — Mode Comparer : deux fichiers analysés, puis pistes
 * appariées, profil « mon fichier idéal », critères, synthèse, images côte à
 * côte et récupération d'une piste. Expose window.Compare. */
(function () {
  'use strict';

  var F = window.MediaFormat;
  var K = window.MediaFindings;
  var section = document.getElementById('compare');
  var cols = document.getElementById('compareCols');
  var body = document.getElementById('compareBody');
  var X = window.MediaCompare;
  var A = window.MediaActions;
  var LS_IDEAL = 'meta-lab.ideal';
  var manual = {};
  var ideal = loadIdeal();

  function loadIdeal() {
    try { var v = JSON.parse(localStorage.getItem(LS_IDEAL)); if (v && typeof v === 'object') return Object.assign({}, X.IDEAL_DEFAULT, v); } catch (_) {}
    return Object.assign({}, X.IDEAL_DEFAULT);
  }
  function saveIdeal() { try { localStorage.setItem(LS_IDEAL, JSON.stringify(ideal)); } catch (_) {} }
  var worker = null;
  var slots = []; // { file, model, raw, summary, diags, error }
  var jobId = 0;

  function R() { return window.Routes; }

  function receive(files) {
    if (files.length === 1) {
      if (slots.length === 1) return start([slots[0].file, files[0]]);
      slots = [{ file: files[0] }];
      render();
      R().showGuide(R().text('second', { name: files[0].name }));
      return;
    }
    if (files.length === 2) return start(files);
    pickTwo(files);
  }

  function pickTwo(files) {
    var body = '<ul class="guide-list">' + files.map(function (f, i) {
      return '<li><label><input type="checkbox" data-pick="' + i + '"> ' + F.esc(f.name) + '</label></li>';
    }).join('') + '</ul><button type="button" class="act tiny" data-compare disabled>' + F.esc(R().text('compare')) + '</button>';
    R().showGuide(R().text('pick-two'), body);
    var guideBody = document.getElementById('guideBody');
    function picked() { return Array.prototype.filter.call(guideBody.querySelectorAll('[data-pick]'), function (c) { return c.checked; }); }
    guideBody.onchange = function () { guideBody.querySelector('[data-compare]').disabled = picked().length !== 2; };
    guideBody.onclick = function (e) {
      if (!e.target.closest('[data-compare]')) return;
      var two = picked().map(function (c) { return files[+c.getAttribute('data-pick')]; });
      if (two.length === 2) start(two);
    };
  }

  function start(two) {
    R().hideGuide();
    manual = {};
    abRevoke();
    ab.state = 'idle'; ab.pos = 0; ab.zoom = null;
    slots = two.map(function (f) { return { file: f }; });
    jobId++;
    render();
    analyzeNext(jobId);
  }

  function ensureWorker() {
    if (!worker) worker = new Worker(new URL('./workers/analyze.worker.js', import.meta.url), { type: 'module' });
    return worker;
  }

  // L'un après l'autre, avec le même Worker.
  function analyzeNext(job) {
    var i = -1;
    for (var k = 0; k < slots.length; k++) if (!slots[k].model && !slots[k].error) { i = k; break; }
    if (i < 0) return;
    var w = ensureWorker();
    w.onmessage = function (e) {
      var m = e.data || {};
      if (m.jobId !== job * 10 + i) return;
      if (m.type === 'result') {
        slots[i].model = m.model; slots[i].raw = m.raw;
        slots[i].summary = window.MediaSummary.describe(m.model);
        slots[i].diags = window.MediaDiagnostics.diagnose(m.model, null);
      } else if (m.type === 'error') slots[i].error = m.error;
      else return;
      render();
      analyzeNext(job);
    };
    w.postMessage({ type: 'analyze', file: slots[i].file, jobId: job * 10 + i });
  }

  function render() {
    section.hidden = !slots.length || R().current() !== 'comparer';
    if (window.App) window.App.refreshEmpty();
    cols.innerHTML = slots.map(function (s, i) {
      var head = '<p class="cmp-letter">' + String.fromCharCode(65 + i) + '</p><p class="cmp-name">' + F.esc(s.file.name) + '</p>';
      if (s.error) return '<div class="cmp-col">' + head + '<p class="cmp-err">' + F.esc(s.error) + '</p></div>';
      if (!s.model) return '<div class="cmp-col" aria-busy="true">' + head + '<p class="cmp-wait">…</p></div>';
      var n = F.gapCounts(K.collect({ diagnostics: s.diags }));
      var c = s.model.container;
      var kpis = [['Taille', F.fmt.bytes(c.fileSize)], ['Durée', F.fmt.duration(c.duration)], ['Débit', F.fmt.bitrate(c.overallBitRate)]]
        .filter(function (k) { return k[1]; })
        .map(function (k) { return '<div class="kpi"><span class="kpi-lbl">' + F.esc(k[0]) + '</span><span class="kpi-val">' + F.esc(k[1]) + '</span></div>'; })
        .join('');
      return '<div class="cmp-col card">' + head +
        '<div class="kpi-row">' + kpis + '</div>' +
        '<p class="cmp-sum">' + F.esc(s.summary) + '</p>' +
        '<p class="cmp-gaps">' + K.PRIORITY_ORDER.map(function (p) {
          return '<span class="gcount ' + p + (n[p] ? '' : ' zero') + '" title="' + F.esc(K.PRIORITIES[p]) + '">' +
            '<span class="sr-only">' + F.esc(K.PRIORITIES[p]) + ' : </span>' + n[p] + '</span>';
        }).join('') + '</p>' +
        '<button type="button" class="act tiny secondary" data-detail="' + i + '">' + F.esc(document.getElementById('tabDetails').textContent) + '</button></div>';
    }).join('');
    renderBody();
  }

  /* ---------- Comparaison ---------- */
  function ready() { return slots.length === 2 && slots[0].model && slots[1].model; }

  function renderBody() {
    if (!ready()) { body.innerHTML = ''; return; }
    var L = X.LABELS;
    var ma = slots[0].model, mb = slots[1].model;
    var res = X.compare(ma, mb, { manual: manual, ideal: ideal, names: { a: slots[0].file.name, b: slots[1].file.name } });
    body.innerHTML = idealHtml(L) + pairsHtml(res, ma, mb, L) + criteriaHtml(res, L) +
      summaryHtml(res, L) + abHtml(L) + recoverHtml(res, L, ma, mb);
  }

  function trackName(m, kind, n) {
    if (n == null) return '—';
    var t = m.tracks.filter(function (x) { return x.kind === kind && x.ordinal === n; })[0];
    var bits = [X.KIND_LABEL[kind] + ' ' + n];
    if (t.language && (t.language.name || t.language.raw)) bits.push(t.language.name || t.language.raw);
    if (t.format) bits.push(t.format);
    if (t.title) bits.push('« ' + t.title + ' »');
    return bits.join(' · ');
  }

  function idealHtml(L) {
    var langs = A.LANGUAGES.filter(function (l) { return l.iso1; });
    function boxes(key) {
      return '<fieldset class="cmp-langs"><legend>' + F.esc(L[key]) + '</legend>' + langs.map(function (l) {
        return '<label><input type="checkbox" data-ideal="' + key + '" value="' + l.iso1 + '"' + (ideal[key].indexOf(l.iso1) >= 0 ? ' checked' : '') + '> ' + F.esc(l.label) + '</label>';
      }).join('') + '</fieldset>';
    }
    var prefs = Object.keys(L.prefs).map(function (k) {
      return '<label class="cmp-pref">' + F.esc(L.prefs[k]) + ' <select data-ideal="' + k + '">' + Object.keys(L.prefValues).map(function (v) {
        return '<option value="' + v + '"' + (ideal[k] === v ? ' selected' : '') + '>' + F.esc(L.prefValues[v]) + '</option>';
      }).join('') + '</select></label>';
    }).join('');
    return '<details class="cmp-block cmp-ideal"><summary>' + F.esc(L.ideal) + '</summary><p class="cmp-hint">' + F.esc(L.idealHint) + '</p>' +
      boxes('audioLanguages') + boxes('subtitleLanguages') + '<div class="cmp-prefs">' + prefs + '</div>' +
      '<button type="button" class="act tiny" data-ideal-apply>' + F.esc(L.apply) + '</button></details>';
  }

  function pairsHtml(res, ma, mb, L) {
    var rows = res.pairs.map(function (p) {
      var bCell = F.esc(trackName(mb, p.kind, p.b));
      if (p.ambiguous && p.a != null) {
        var options = mb.tracks.filter(function (t) { return t.kind === p.kind; });
        bCell = '<select data-pair-kind="' + p.kind + '" data-pair-a="' + p.a + '" aria-label="' + F.esc(L.ambiguous) + '"><option value="">—</option>' +
          options.map(function (t) { return '<option value="' + t.ordinal + '"' + (t.ordinal === p.b ? ' selected' : '') + '>' + F.esc(trackName(mb, p.kind, t.ordinal)) + '</option>'; }).join('') + '</select>';
      }
      return '<tr><td>' + F.esc(trackName(ma, p.kind, p.a)) + '</td><td>' + bCell + '</td><td class="cmp-reasons">' + F.esc(p.reasons.join(', ')) + '</td></tr>';
    }).join('');
    var amb = res.pairs.some(function (p) { return p.ambiguous; }) ? '<p class="cmp-hint">' + F.esc(L.ambiguous) + '</p>' : '';
    return '<section class="cmp-block"><h4>' + F.esc(L.pairs) + '</h4>' + amb + '<div class="cmp-tablewrap"><table class="cmp-table"><thead><tr><th>A</th><th>B</th><th>' +
      F.esc(L.reasonsHead) + '</th></tr></thead><tbody>' + rows + '</tbody></table></div></section>';
  }

  function criterionRow(r, L) {
    var adv = r.advantage == null ? '' : F.esc(L.advantage[r.advantage]) + (r.indifferent ? ' <span class="cmp-indiff">(' + F.esc(L.indifferent) + ')</span>' : '');
    function cell(v) { return F.esc(v.text) + ' <span class="origin">' + F.esc(window.MediaFindings.ORIGINS[v.origin]) + '</span>'; }
    return '<tr class="adv-' + (r.advantage || 'none') + '"><th scope="row">' + F.esc(r.label) + '</th><td>' + cell(r.a) + '</td><td>' + cell(r.b) + '</td><td>' + adv + '</td></tr>';
  }

  function criteriaHtml(res, L) {
    var head = '<thead><tr><th>' + F.esc(L.criterion) + '</th><th>A</th><th>B</th><th>' + F.esc(L.advantageHead) + '</th></tr></thead>';
    var diff = res.rows.filter(function (r) { return !r.same; }), same = res.rows.filter(function (r) { return r.same; });
    return '<section class="cmp-block"><h4>' + F.esc(L.criteria) + '</h4><div class="cmp-tablewrap"><table class="cmp-table">' + head + '<tbody>' +
      diff.map(function (r) { return criterionRow(r, L); }).join('') + '</tbody></table></div>' +
      (same.length ? '<details><summary>' + F.esc(L.sameCriteria) + ' · ' + same.length + '</summary><div class="cmp-tablewrap"><table class="cmp-table">' + head + '<tbody>' +
        same.map(function (r) { return criterionRow(r, L); }).join('') + '</tbody></table></div></details>' : '') + '</section>';
  }

  function summaryHtml(res, L) {
    var s = res.summary;
    function list(items) { return '<ul class="cmp-list">' + items.map(function (x) { return '<li>' + F.esc(x) + '</li>'; }).join('') + '</ul>'; }
    return '<section class="cmp-block cmp-summary"><h4>' + F.esc(L.summary) + '</h4>' +
      '<p class="cmp-class">' + F.esc(s.classification.text) + '</p>' +
      '<h5>' + F.esc(L.concluded) + '</h5>' + list(s.concluded) +
      '<h5>' + F.esc(L.needsImage) + '</h5>' + list(s.needsImage) +
      '<p class="cmp-reco">' + F.esc(s.recommendation.text) + '</p></section>';
  }

  /* ---------- Regarder l'image ----------
   * Les mêmes instants des deux fichiers, en pleine définition, côte à côte,
   * avec une vue au point près. */

  // Cinq endroits, aux mêmes proportions du film des deux côtés.
  var LOOK_AT = [0.15, 0.3, 0.45, 0.6, 0.75];

  var ab = { state: 'idle', sets: [null, null], pos: 0, zoom: null, progress: 0, message: '', proportional: false };
  var abWorker = null;

  function abEnsureWorker() {
    if (!abWorker) abWorker = new Worker(new URL('./workers/packets.worker.js', import.meta.url), { type: 'module' });
    return abWorker;
  }

  function abRevoke() {
    ab.sets.forEach(function (set) {
      (set || []).forEach(function (f) { if (f && f.url) URL.revokeObjectURL(f.url); });
    });
    ab.sets = [null, null];
  }

  function abRun() {
    var da = slots[0].model.container.duration, db = slots[1].model.container.duration;
    if (!da || !db) return;
    abRevoke();
    ab.state = 'running'; ab.progress = 0; ab.pos = 0; ab.zoom = null; ab.message = '';
    ab.proportional = Math.abs(da - db) > 1;
    renderBody();

    var w = abEnsureWorker();
    var job = Date.now();
    var index = 0;
    var durations = [da, db];
    function next() {
      if (index > 1) { ab.state = 'done'; renderBody(); return; }
      w.postMessage({
        type: 'frames', file: slots[index].file, jobId: job + index,
        timestamps: LOOK_AT.map(function (f) { return Math.round(durations[index] * f * 1000) / 1000; })
      });
    }
    w.onmessage = function (e) {
      var m = e.data || {};
      if (m.jobId !== job + index) return;
      if (m.type === 'progress') { ab.progress = (index + m.progress) / 2; renderBody(); return; }
      if (m.type === 'error') { ab.state = 'error'; ab.message = m.error; renderBody(); return; }
      if (m.type !== 'frames') return;
      ab.sets[index] = (m.result.frames || []).map(function (f) {
        return f && Object.assign({ url: URL.createObjectURL(f.blob) }, f);
      });
      index++;
      next();
    };
    w.onerror = function (ev) { ab.state = 'error'; ab.message = ev.message || 'Extraction impossible.'; renderBody(); };
    next();
  }

  function abSameShot() {
    var P = window.MediaPicture;
    var a = ab.sets[0] && ab.sets[0][ab.pos], b = ab.sets[1] && ab.sets[1][ab.pos];
    if (!P || !a || !b || !a.thumb || !b.thumb) return true;
    return P.sameShot(a.thumb, b.thumb);
  }

  function abPaneHtml(i, L) {
    var letter = String.fromCharCode(65 + i);
    var f = ab.sets[i] && ab.sets[i][ab.pos];
    if (!f) {
      return '<figure class="ab-pane"><div class="ab-box ab-empty"></div>' +
        '<figcaption>' + letter + ' — ' + F.esc(L.lookNoVideo) + '</figcaption></figure>';
    }
    var img, boxStyle;
    if (ab.zoom) {
      // le point visé est amené au centre, des deux côtés à la fois
      img = '<img src="' + f.url + '" alt="" class="ab-img zoomed" style="width:' + f.width + 'px;height:' + f.height +
        'px;transform:translate(' + (-Math.round(f.width * ab.zoom.fx)) + 'px,' + (-Math.round(f.height * ab.zoom.fy)) + 'px)">';
      boxStyle = '';
    } else {
      img = '<img src="' + f.url + '" alt="" class="ab-img">';
      boxStyle = ' style="aspect-ratio:' + f.width + '/' + f.height + '"';
    }
    var caption = letter + ' · ' + f.width + ' × ' + f.height + ' px' +
      (f.scaled ? ' (' + L.lookScaled + ')' : '') + ' · ' + (F.fmt.duration(f.timestamp) || '0 s');
    return '<figure class="ab-pane"><div class="ab-box' + (ab.zoom ? ' zoom' : '') + '" data-ab-pane="' + i + '"' + boxStyle + '>' +
      img + '</div><figcaption>' + F.esc(caption) + '</figcaption></figure>';
  }

  function abHtml(L) {
    var head = '<section class="cmp-block cmp-ab"><h4>' + F.esc(L.look) + '</h4>' +
      '<p class="cmp-hint">' + F.esc(L.lookHint) + '</p>';
    if (ab.state === 'running') {
      return head + '<p class="cmp-hint">' + F.esc(L.lookBusy) + '</p>' +
        '<progress value="' + Math.round(ab.progress * 100) + '" max="100"></progress></section>';
    }
    if (ab.state === 'error') {
      return head + '<p class="cmd-warn">' + F.esc(ab.message) + '</p>' +
        '<button type="button" class="act tiny secondary" data-ab-run>' + F.esc(L.lookRun) + '</button></section>';
    }
    if (ab.state !== 'done') {
      return head + '<button type="button" class="act tiny" data-ab-run>' + F.esc(L.lookRun) + '</button></section>';
    }
    var tabs = LOOK_AT.map(function (_, n) {
      var f = (ab.sets[0] || [])[n];
      var label = f ? (F.fmt.duration(f.timestamp) || '0 s') : X.LABELS.lookPosition.replace('{n}', n + 1);
      return '<button type="button" class="comp-tag' + (n === ab.pos ? ' on' : '') + '" data-ab-pos="' + n + '"' +
        (n === ab.pos ? ' aria-current="true"' : '') + '>' + F.esc(label) + '</button>';
    }).join('');
    var notes = '';
    if (!abSameShot()) notes += '<p class="cmd-warn">' + F.esc(L.lookDifferent) + '</p>';
    if (ab.proportional) notes += '<p class="cmp-hint">' + F.esc(L.lookProportional) + '</p>';
    notes += '<p class="cmp-hint">' + F.esc(ab.zoom ? L.lookZoomOn : L.lookZoomHint) + '</p>';
    return head + '<div class="ab-tabs">' + tabs + '</div>' + notes +
      '<div class="ab-panes">' + abPaneHtml(0, L) + abPaneHtml(1, L) + '</div>' +
      (ab.zoom ? '<button type="button" class="act tiny secondary" data-ab-fit>' + F.esc(L.lookFit) + '</button> ' : '') +
      '<button type="button" class="act tiny secondary" data-ab-run>' + F.esc(L.lookAgain) + '</button></section>';
  }

  // Un clic désigne un point : il ouvre la vue au point près, ou s'y déplace.
  body.addEventListener('click', function (e) {
    var pane = e.target.closest('[data-ab-pane]');
    if (!pane) return;
    var i = +pane.getAttribute('data-ab-pane');
    var f = ab.sets[i] && ab.sets[i][ab.pos];
    if (!f) return;
    var r = pane.getBoundingClientRect();
    var cx = e.clientX - r.left, cy = e.clientY - r.top;
    if (!ab.zoom) {
      ab.zoom = { fx: Math.min(1, Math.max(0, cx / r.width)), fy: Math.min(1, Math.max(0, cy / r.height)) };
    } else {
      // le centre de la fenêtre montre déjà (fx, fy) : le clic s'y ajoute
      ab.zoom = {
        fx: Math.min(1, Math.max(0, ab.zoom.fx + (cx - r.width / 2) / f.width)),
        fy: Math.min(1, Math.max(0, ab.zoom.fy + (cy - r.height / 2) / f.height))
      };
    }
    renderBody();
  });

  function recoverHtml(res, L, ma, mb) {
    if (!res.recover.length) return '';
    var env = window.ActionsUI ? window.ActionsUI.env() : 'posix';
    return '<section class="cmp-block"><h4>' + F.esc(L.recover) + '</h4>' + res.recover.map(function (x) {
      var target = x.into === 'A' ? slots[0] : slots[1];
      var steps = A.render(A.plan([x.action], { fileName: target.file.name, model: target.model }), env);
      var text = steps[0].lines.join('\n');
      return '<div class="cmp-recover"><p><strong>' + F.esc(x.action.params.label) + '</strong> ' + F.esc(X.LABELS.into.replace('{side}', x.into)) + '</p>' +
        '<p>' + F.esc(A.explain(x.action)) + '</p>' +
        x.action.warnings.map(function (w) { return '<p class="cmd-warn">' + F.esc(A.WARNINGS[w]) + '</p>'; }).join('') +
        '<p class="cmd-head"><span class="cmd-nature remux">' + F.esc(A.natureLabel('remux')) + '</span> <span class="mono">mkvmerge</span> · ' + F.esc(A.ENVIRONMENTS[env]) + '</p>' +
        '<pre class="cmd"><code>' + F.esc(text) + '</code></pre>' +
        '<button type="button" class="act tiny secondary" data-copytext="' + F.esc(text) + '">' + F.esc(A.LABELS.copy) + '</button></div>';
    }).join('') + '<p class="cmd-note">' + F.esc(A.LABELS.runIn) + '</p></section>';
  }

  body.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-pair-kind')) {
      var k = t.getAttribute('data-pair-kind');
      var m = manual[k] || {};
      if (!manual[k]) {
        Array.prototype.forEach.call(body.querySelectorAll('select[data-pair-kind="' + k + '"]'), function (s) {
          m[+s.getAttribute('data-pair-a')] = s.value ? +s.value : null;
        });
      }
      m[+t.getAttribute('data-pair-a')] = t.value ? +t.value : null;
      manual[k] = m;
      renderBody();
    }
  });
  body.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    if (b.hasAttribute('data-ideal-apply')) {
      var next = Object.assign({}, X.IDEAL_DEFAULT, { audioLanguages: [], subtitleLanguages: [] });
      Array.prototype.forEach.call(body.querySelectorAll('[data-ideal]'), function (el) {
        var k = el.getAttribute('data-ideal');
        if (el.type === 'checkbox') { if (el.checked) next[k].push(el.value); }
        else next[k] = el.value;
      });
      ideal = next;
      saveIdeal();
      renderBody();
      var d = body.querySelector('.cmp-ideal'); if (d) d.open = true;
    } else if (b.hasAttribute('data-ab-run')) {
      abRun();
    } else if (b.hasAttribute('data-ab-pos')) {
      ab.pos = +b.getAttribute('data-ab-pos');
      renderBody();
    } else if (b.hasAttribute('data-ab-fit')) {
      ab.zoom = null;
      renderBody();
    } else if (b.hasAttribute('data-copytext') && window.ActionsUI) {
      window.ActionsUI.copyText(b.getAttribute('data-copytext'), b);
    }
  });

  cols.addEventListener('click', function (e) {
    var b = e.target.closest('[data-detail]');
    if (!b) return;
    var s = slots[+b.getAttribute('data-detail')];
    window.App.showDetail({ file: s.file, model: s.model, raw: s.raw, summary: s.summary, diags: s.diags }, { tab: 'details' });
  });

  window.Compare = {
    receive: receive,
    isActive: function () { return slots.length > 0; },
    show: function () { render(); if (slots.length === 1) R().showGuide(R().text('second', { name: slots[0].file.name })); },
    hide: function () { section.hidden = true; }
  };
})();
